import React from "react";
import styled from "styled-components";
import {
  brand_orange_deep,
  card_shadow_sm,
  outerContainerCss,
  narrowScreenMediaQuery,
} from "../constants/styles";

// Primitive surfaces consumed by every portal page. Centralises
// padding/radius/shadow/dark-mode treatment so the page components stay
// declarative and a future visual tweak lands in one file.
//
// Usage:
//   <PortalContainer>
//     <PortalSection title="Profil Pribadi" subtitle="…">
//       <PortalCard>…</PortalCard>
//     </PortalSection>
//   </PortalContainer>

export const PortalContainer = styled.div`
  ${outerContainerCss}
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media ${narrowScreenMediaQuery} { gap: 20px; }
`;

const SectionWrap = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const SectionHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #1f2937;
  letter-spacing: -0.005em;

  [data-theme="dark"] & { color: #f3f4f6; }
`;

const SectionSubtitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;

  [data-theme="dark"] & { color: #9ca3af; }
`;

export function PortalSection({ title, subtitle, action, children, ...rest }) {
  return (
    <SectionWrap {...rest}>
      {(title || action) && (
        <SectionHead>
          {(title || action) && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
              {title && <SectionTitle>{title}</SectionTitle>}
              {action}
            </div>
          )}
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </SectionHead>
      )}
      {children}
    </SectionWrap>
  );
}

export const PortalCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 22px 24px;
  box-shadow: ${card_shadow_sm};

  @media ${narrowScreenMediaQuery} { padding: 18px 18px; }

  [data-theme="dark"] & {
    background: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.08);
    box-shadow: none;
  }
`;

export const PortalCardTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 800;
  color: ${brand_orange_deep};
  letter-spacing: 0.02em;
`;

// Convenience: a flat empty-state panel for "no data" body sections.
export const PortalEmpty = styled.div`
  background: rgba(15, 23, 42, 0.02);
  border: 1px dashed rgba(15, 23, 42, 0.12);
  border-radius: 14px;
  padding: 28px 24px;
  text-align: center;
  font-size: 14px;
  color: #6b7280;

  [data-theme="dark"] & {
    background: rgba(255, 255, 255, 0.02);
    border-color: rgba(255, 255, 255, 0.10);
    color: #9ca3af;
  }
`;
